/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import {
    MyShowsUserSettings,
    MyShowsUserSettingsOptions,
    MyShowsUserSettingsValue,
} from 'client-code/user-settings';

import type { TivoPayloadAction } from '../../../../core/tivo/tivo-redux-wrapper';
import {
    SET_MY_SHOWS_USER_SETTINGS_ERROR,
    SET_MY_SHOWS_USER_SETTINGS_FOCUSED_OPTION_INDEX,
    SET_MY_SHOWS_USER_SETTINGS_OPTIONS,
    SET_MY_SHOWS_USER_SETTINGS_VALUE,
} from './myshowsoptionsmenu.types';

export const setMyShowsOptionsFocusedIndexAction = (
    focusedOptionIndex: number,
    isFocused: boolean,
): TivoPayloadAction<
    Partial<MyShowsUserSettings & { focusedOptionIndex: number; isFocused: boolean }>
> => ({
    type: SET_MY_SHOWS_USER_SETTINGS_FOCUSED_OPTION_INDEX,
    payload: {
        focusedOptionIndex,
        isFocused,
    },
});

export const setMyShowsUserSettingsOptionsAction = (
    myShowsUserSettingsOptions: MyShowsUserSettingsOptions,
): TivoPayloadAction<Partial<MyShowsUserSettings & { focusedOptionIndex: number }>> => ({
    type: SET_MY_SHOWS_USER_SETTINGS_OPTIONS,
    payload: {
        settingsOptions: myShowsUserSettingsOptions,
    },
});

export const setMyShowsUserSettingsValueAction = (
    myShowsUserSettingsValue: MyShowsUserSettingsValue,
): TivoPayloadAction<Partial<MyShowsUserSettings & { focusedOptionIndex: number }>> => ({
    type: SET_MY_SHOWS_USER_SETTINGS_VALUE,
    payload: {
        settingsValues: myShowsUserSettingsValue,
    },
});

export const setMyShowsUserSettingsErrorAction = (hasError: boolean) => ({
    type: SET_MY_SHOWS_USER_SETTINGS_ERROR,
    payload: {
        hasError,
    },
});
